import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INTIATE_VIEW_INTRODUCTION_DATA,
  SET_VIEW_INTRODUCTION_DATA,
  SET_VIEW_INTRODUCTION_DATA_FAIL,
} from "../../actionTypes/dashboard";
import ViewIntroduction from "../../../services/api/viewIntroduction";

// onSuccess handler for pending transfer data api
const onIntroductionDataSuccess = (payload) => ({
  type: SET_VIEW_INTRODUCTION_DATA,
  payload,
});

// onFail handler for pending transfer data api
const onIntroductionDataFail = (payload) => ({
  type: SET_VIEW_INTRODUCTION_DATA_FAIL,
  payload,
});

/**
 * This function handles the pending friends data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getIntroductionData(action) {
  try {
    const response = yield call(
      ViewIntroduction.getIntroductionData,
      action.payload
    );
    yield put(
      onIntroductionDataSuccess({
        data: response.content,
        paginationInfo: {
          currentPage: Number(response.number),
          totalPages: Number(response.totalPages),
          totalElements: Number(response.totalElements),
          pageSize: Number(response.size),
        },
      })
    );
  } catch (error) {
    yield put(onIntroductionDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * Watcher saga for friends
 */
function* watchIntroductionsSaga() {
  yield takeLatest(INTIATE_VIEW_INTRODUCTION_DATA, getIntroductionData);
}
export default watchIntroductionsSaga;
